<template>
    <app-content-admin>
        <template slot="header">{{ $t("A01654") }}</template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-form @submit.prevent="search()" autocomplete="off">
                    <v-layout row wrap>
                        <v-flex xs12 sm3>
                            <v-text-field :label="$t('M00109')" v-model="form.name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3>
                            <v-text-field :label="$t('A00041')" v-model="form.email"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3>
                            <v-text-field :label="$t('A00050')" type="date" v-model="form.from_date"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3>
                            <v-text-field :label="$t('A00051')" type="date" v-model="form.to_date"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" type="submit" class="form-submit mr-4">{{$t('search')}}</v-btn>                            
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>

            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">{{$t('S00046')}}</th>
                            <th scope="col">{{$t('A00041')}}</th>
                            <th scope="col">{{$t('A00064')}}</th>
                            <th scope="col">{{$t('A00163')}}</th>
                            <th scope="col">{{$t('M00005')}}</th>
                            <th scope="col">{{$t('M00200')}}</th>
                            <th scope="col">{{$t('A00411')}}</th>
                        </thead>
                        <tbody>
                            <tr class="text-center" v-for="row in rows" :key="row.id">
                                <td :data-label="$t('name')">{{ row.name }}</td>
                                <td :data-label="$t('email')" class="text-truncate">{{ row.email }}</td>
                                <td :data-label="$t('mobile_no')">{{ row.mobile_no }}</td>
                                <td :data-label="$t('join_date')" class="text-truncate" :title="row.created_at">
                                    {{ row.created_at }}
                                </td>
                                <td :data-label="$t('M00200')">
                                    <v-icon v-if="row.can_login == 1" color="green">check_circle</v-icon>
                                    <v-icon v-else color="error">cancel</v-icon>
                                </td>
                                <td :data-label="$t('M00200')">
                                    <active-label :status="row.status"></active-label>
                                </td>
                                <td :data-label="$t('action')">
                                    <v-menu :close-on-content-click="true" :nudge-width="200" :open-on-click="true" offset-y
                                        offset-x left>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" text small icon v-on="on">
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="editProfile(row.id)">
                                                <v-list-item-action>
                                                    {{$t('A00209')}}
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <v-layout justify-center>
                        <v-flex xs8>
                            <div class="text-xs-center" v-if="pages > 0">
                                <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';

export default {
    mixins: [vForm],

    data(){
        const test = [{
            "name":"yoyo",
            "email":"yoyo2asd.com"
        },
        {
            "name":"gay"
        }]
        return {              
              rows:[...test],
              pages:0,
              page:1,
              form: {
                  page: 1,
                  offset: 10,
              }              
          }
        },

        components: {ActiveLabel},

        async created() {
            await this.search();
        },

        methods: {
            search(offset = 10, page = 1) {
                this.form.offset = offset;
                this.form.page = page;

                let loader = this.$loading.show();

                axios.post(api.path('member.list'), this.form)
                    .then(res => res.data)
                    .then(res => {
                            this.rows = res.data.data;
                            this.pages = res.data.pages;
                    })
                    .catch(e=>{
                        this.$toastr.e(e.message);
                    })
                    .finally(()=>{
                        loader.hide();
                    })
            },

            onListChange(page) {
                this.search(10, page);
            },

            editProfile(id) {
                this.$router.push({name: 'member_detail', params: {user_id: id}});
            },
        
        }
}
</script>